import type {
  ErrorResponse,
  SugarmateError,
} from "@tandemdiabetes/sugarmate-api-react-client"
import { isAxiosError } from "axios"

export function getSugarmateError(e: unknown): SugarmateError | undefined {
  if (isAxiosError(e) && e.response) {
    const data = e.response.data as ErrorResponse
    return data.error
  }

  return undefined
}
